module.exports = __webpack_public_path__ + "32c9f6b089b315707f5267c80a31285c.pdf";